<template>
    <!-- commento test -->
    <div id="app" :class="['partner-' + $root.source]">
        <v-app>
            <!--<webview-top-bar
				v-if="$mq.isWV() && user"
			/>-->

            <div
                id="app-view"
                ref="appView"
                :style="user ? $_appViewPosition_margins : null"
            >
                <offline-overlay />

                <sign-in ref="signinModal" :activeModal.sync="activeModal" @openModal="openModal" />
                <sign-up ref="signupModal" :activeModal.sync="activeModal" @success="activeModalDetail" @openModal="openModal" />

                <navigation-component :user="user" @openModal="openModal" />
                <div class="ct-offset" :class="$route.meta.header ===  false ? 'ct-offset-order-now' : ''">
                    <router-view :user="user" @openModal="openModal" />
                </div>

                <footer-component :user="user" v-if="!$mq.isWV()" />

                <!--<cookies-bar
					v-if="!$mq.isWV()"
				/>-->
            </div>

            <webview-bottom-navigation v-if="$mq.isWV() && user" />

            <!--<newsletter-modal 
	      		:activeModal="activeModal" 
	      	/>-->

            <billing-cart class="mt-1 ml-3 mr-3" :icon="false" :bill="true" />
            <!--<chat-container
				v-if="!$mq.isWV()"
			/>-->
        </v-app>
    </div>
</template>

<script>
import NewsletterModal from "@/components/Parts/NewsletterModal";
//import ChatContainer from '@/components/Parts/ChatContainer'
import CookiesBar from "@/components/Parts/CookiesBar";
import BillingCart from "@/components/Checkout/BillingCart";

import WebviewBottomNavigation from "@/components/Webview/WebviewBottomNavigation";
import OfflineOverlay from "./components/Webview/OfflineOverlay";
import WebviewTopBar from "@/components/Webview/WebviewTopBar";
import NavigationComponent from "@/components/Nav";
import FooterComponent from "@/components/Footer";
import SignIn from "@/components/SignIn";
import SignUp from "./components/SignUp";
import { container } from "./services/container";

import { dataLayer } from "./mixins/gtc";
import { seo } from "./mixins/seo";
require("bootstrap/dist/css/bootstrap.css");
require("bootstrap/dist/js/bootstrap.bundle.js");
require("bootstrap-vue/dist/bootstrap-vue.css");
require("bootstrap-social/bootstrap-social.css");
require("font-awesome/css/font-awesome.min.css");
require("flickity/css/flickity.css");
require("./assets/styles/main.css");
require("./assets/styles/btn.css");
require("./assets/styles/password.css");
require("./assets/styles/feedaty.css");
require("./assets/styles/transitions.css");
require("./assets/styles/fontawesome-all.css");
require("./assets/js/pwa.js");
require("./partners/galbani/galbani.scss");
require("./partners/bennet/bennet.scss");

window.$ = window.jQuery = require("jquery");

export default {
    name: "app",
    components: {
        NavigationComponent,
        SignIn,
        SignUp,
        FooterComponent,
        CookiesBar,
        WebviewTopBar,
        OfflineOverlay,
        //ChatContainer,
        BillingCart,
        NewsletterModal,
        WebviewBottomNavigation,
    },

    mixins: [seo, dataLayer],

    data() {
        return {
            windowWidth: window.innerWidth,
            activeModal: null,
            container: container,
            activeModalDetail: ()=>{}
        };
    },

    watch: {
        $route() {
            this.closeAllModal();
            this.$nextTick(() => {
                this.$_dataLayer_dataLayerActivate();
            });
        },
    },

    computed: {
        user() {
            return this.$root.user;
        },
    },

    methods: {
        closeAllModal() {
            this.$refs.signinModal.$children[0].close();
        },

        openModal(target) {
            if (target === "signin") this.$refs.signinModal.$children[0].open();
            if (target === "signup") this.$refs.signupModal.$children[0].open();
            this.activeModal = target
        }
    },

    mounted() {
        this.$_dataLayer_dataLayerActivate();
    },
    
    created () {
        this.$nextTick(() => {
            window.addEventListener("resize", () => {
                this.windowWidth = window.innerWidth;
            });
        });   

        this.listener = (e) => {
            this.openModal('signup')
            this.activeModalDetail = e.detail
        }

        this.listener2 = (e) => {
            this.openModal('signin')
        }

        window.addEventListener('signup-modal', this.listener);
        window.addEventListener('signin-bennet', this.listener2);
    },

    destroyed() {
        window.removeEventListener('signup-modal', this.listener);
        window.removeEventListener('signin-bennet', this.listener2);
    }
};
</script>
<style>
.v-application a {
    color: rgb(84, 84, 91); /* damn vuetify */
}
</style>

<style scoped>
#app-view {
    width: 100%;
}

.ct-offset-order-now {
    padding-top: 0 !important;
}
</style>
